<template>
	<div class="logo-header">
		<div
			class="logo"
			:class="{ 'logo-left': position === 'left' }"
			@click="goHome"
		>
			Cognitive Cloud
		</div>
		<div class="sep" v-if="!noSep"></div>
	</div>
</template>

<script>
export default {
	name: 'LogoHeader',
	props: ['position', 'isLink', 'path', 'noSep'],
	methods: {
		goHome() {
			if (this.isLink) {
				this.$router
					.push({ path: this.path ? this.path : '/console' })
					.catch((err) => {
						if (
							err.name !== 'NavigationDuplicated' &&
							!err.message.includes(
								'Avoided redundant navigation to current location',
							)
						) {
							// eslint-disable-next-line
							console.error(err);
						}
					});
			}
		},
	},
};
</script>